import React from 'react';
import { Link } from 'react-router-dom';

function LegalLayout({ title, children }) {
  return (
    <main className="page" style={{ background: 'var(--bg)' }}>
      <div style={{ background: 'var(--white)', borderBottom: '1px solid var(--border)', padding: 'var(--sp-8) 0 var(--sp-6)' }}>
        <div className="container">
          <div style={{ maxWidth: 800, margin: '0 auto' }}>
            <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 'var(--fs-sm)', color: 'var(--text-muted)', marginBottom: 'var(--sp-4)' }}>
              ← Vissza a főoldalra
            </Link>
            <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(1.6rem,4vw,2.2rem)', fontWeight: 700 }}>{title}</h1>
          </div>
        </div>
      </div>
      <div className="container" style={{ padding: 'var(--sp-10) var(--container-pad) var(--sp-16)' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', background: 'var(--white)', borderRadius: 'var(--r-xl)', border: '1px solid var(--border)', padding: 'clamp(var(--sp-6), 5vw, var(--sp-12))', lineHeight: 1.8 }}>
          {children}
        </div>
      </div>
    </main>
  );
}

const H2 = ({ children }) => <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--fs-xl)', fontWeight: 700, marginTop: 'var(--sp-8)', marginBottom: 'var(--sp-4)', paddingTop: 'var(--sp-4)', borderTop: '1px solid var(--border)' }}>{children}</h2>;
const H3 = ({ children }) => <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--fs-lg)', fontWeight: 600, marginTop: 'var(--sp-5)', marginBottom: 'var(--sp-2)' }}>{children}</h3>;
const P  = ({ children }) => <p style={{ color: 'var(--text-2)', marginBottom: 'var(--sp-3)', fontSize: 'var(--fs-sm)' }}>{children}</p>;
const UL = ({ children }) => <ul style={{ paddingLeft: 'var(--sp-6)', marginBottom: 'var(--sp-3)', display: 'flex', flexDirection: 'column', gap: 'var(--sp-1)' }}>{children}</ul>;
const LI = ({ children }) => <li style={{ color: 'var(--text-2)', fontSize: 'var(--fs-sm)', listStyleType: 'disc' }}>{children}</li>;

/* ─── ÁSZF ──────────────────────────────────────────────── */
export function ASZFPage() {
  return (
    <LegalLayout title="Általános Szerződési Feltételek (ÁSZF)">
      <P style={{ color: 'var(--text-muted)', fontSize: 'var(--fs-xs)' }}>Hatályos: 2026. június 4-től</P>

      <H2>1. Az üzemeltető adatai</H2>
      <P>Cégnév: Fehérvári és Hilbert Kft.<br />Székhely: 6500 Baja, Czirfusz Ferenc u. 41.<br />Cégjegyzékszám: 03-09-125434<br />Adószám: 24161817-2-03<br />E-mail: kftfehervari@gmail.com<br />Telefonszám: +36 70 210 7706</P>

      <H2>2. Az ÁSZF hatálya és elfogadása</H2>
      <P>A jelen ÁSZF tartalmazza a The Cruiser Shop kerékpár szaküzlet (a továbbiakban: Szaküzlet) szolgáltatásainak igénybevételi feltételeit. Szaküzletünkben történő vásárlással a Vásárló elfogadja az ÁSZF rendelkezéseit.</P>

      <H2>3. A termékek és árak</H2>
      <P>Szaküzletünkben az árak forintban (Ft) értendők, és tartalmazzák az általános forgalmi adót (27% ÁFA). Fenntartjuk az árak változtatásának jogát. A vásárláskor meghatározott ár a vásárló számára kötelező érvényű.</P>
      <UL>
        <LI>Az árak az ÁFÁ-t tartalmazzák.</LI>
        <LI>Nyilvánvaló árhiba esetén nem vagyunk kötelesek az érintett terméket az áron értékesíteni.</LI>
      </UL>

      <H2>4. A vásárlás menete</H2>
      <P>Termékeink személyesen vásárolhatók meg szaküzletünkben (6500 Baja, Czirfusz Ferenc u. 41.), illetve telefonon vagy e-mailben leadott megrendelés alapján. Minden vásárláshoz személyes tanácsadást és beüzemelést biztosítunk.</P>

      <H2>5. Fizetési módok</H2>
      <UL>
        <LI><strong>Készpénz</strong> — személyes vásárlásnál</LI>
        <LI><strong>Bankkártya</strong> — biztonságos fizetés szaküzletünkben</LI>
        <LI><strong>Banki átutalás</strong> — egyedi megállapodás alapján</LI>
      </UL>

      <H2>6. Garancia és jótállás</H2>
      <P>Az egyes termékekre vonatkozó jótállási feltételeket a gyártó határozza meg. A fogyasztói szerződés keretében értékesített termékekre a Polgári Törvénykönyv és a 151/2003. (IX. 22.) Korm. rendelet rendelkezései az irányadók.</P>

      <H2>9. Adatvédelem</H2>
      <P>A személyes adatok kezeléséről szóló tájékoztatót az <Link to="/adatvedelem" style={{ color: 'var(--coral)' }}>Adatvédelmi Tájékoztató</Link> tartalmazza.</P>

      <H2>10. Panaszkezelés</H2>
      <P>Panasz esetén kérjük, először vegye fel velünk a kapcsolatot az kftfehervari@gmail.com e-mail-címen. Ha panasza nem rendeződik, az Európai Unió online vitarendezési platformját is igénybe veheti: <a href="https://ec.europa.eu/odr" target="_blank" rel="noreferrer" style={{ color: 'var(--coral)' }}>https://ec.europa.eu/odr</a>.</P>

      <H2>11. Irányadó jog</H2>
      <P>A jelen ÁSZF-re a magyar jog az irányadó, különös tekintettel a Polgári Törvénykönyvről szóló 2013. évi V. törvényre és az elektronikus kereskedelmi szolgáltatásokról szóló 2001. évi CVIII. törvényre.</P>
    </LegalLayout>
  );
}

/* ─── Adatvédelem ───────────────────────────────────────── */
export function AdatvedelemPage() {
  return (
    <LegalLayout title="Adatvédelmi Tájékoztató">
      <P style={{ color: 'var(--text-muted)', fontSize: 'var(--fs-xs)' }}>Hatályos: 2026. június 4-től | GDPR-kompatibilis</P>

      <H2>1. Az adatkezelő</H2>
      <P>Cégnév: Fehérvári és Hilbert Kft.<br />Székhely: 6500 Baja, Czirfusz Ferenc u. 41.<br />Cégjegyzékszám: 03-09-125434<br />E-mail: kftfehervari@gmail.com<br />Adatvédelmi kapcsolat: kftfehervari@gmail.com</P>

      <H2>2. Milyen adatokat kezelünk?</H2>
      <H3>Regisztrációkor</H3>
      <UL>
        <LI>Teljes név</LI>
        <LI>E-mail cím</LI>
        <LI>Telefonszám (opcionális)</LI>
        <LI>Titkosított jelszó</LI>
      </UL>
      <H3>Vásárláskor</H3>
      <UL>
        <LI>Név, telefonszám (kapcsolattartáshoz)</LI>
        <LI>Megvásárolt termékek és összegek (számlázáshoz)</LI>
        <LI>Szállítási cím (ha kiszállítást kér)</LI>
      </UL>
      <H3>Automatikusan gyűjtött adatok</H3>
      <UL>
        <LI>IP-cím (anonimizálva, 30 nap után törlés)</LI>
        <LI>Böngésző típusa, látogatás időpontja</LI>
        <LI>Cookie-adatok (ld. lent)</LI>
      </UL>

      <H2>3. Az adatkezelés célja és jogalapja</H2>
      <UL>
        <LI><strong>Szerződés teljesítése</strong> — vásárlás feldolgozása, számlázás (GDPR 6. cikk (1) b)</LI>
        <LI><strong>Jogos érdek</strong> — visszaélések megelőzése, biztonság (GDPR 6. cikk (1) f)</LI>
        <LI><strong>Jogi kötelezettség</strong> — számviteli megőrzési kötelezettség (GDPR 6. cikk (1) c)</LI>
        <LI><strong>Hozzájárulás</strong> — marketing e-mailek, elemzési sütik (GDPR 6. cikk (1) a)</LI>
      </UL>

      <H2>4. Cookie (süti) szabályzat</H2>
      <H3>Szükséges sütik</H3>
      <P>A weboldal működéséhez elengedhetetlenek: munkamenet-kezelés, biztonsági token. Hozzájárulás nélkül is aktívak.</P>
      <H3>Elemzési sütik</H3>
      <P>Weboldalhasználati statisztikák gyűjtéséhez. Az oldal a <strong>Google Analytics 4</strong> (Google LLC) szolgáltatást használja, amely sütiket helyez el a látogató eszközén. Az összegyűjtött adatok anonimizáltak, és az EU–US Data Privacy Framework alapján kerülnek feldolgozásra. Csak hozzájárulással aktívak.</P>
      <H3>Marketing sütik</H3>
      <P>Személyre szabott hirdetések megjelenítéséhez. Csak hozzájárulással aktívak.</P>
      <P>A sütik beállításait bármikor módosíthatod a cookie-beállítások megnyitásával vagy a böngésző beállításaiban.</P>

      <H2>5. Adattovábbítás</H2>
      <UL>
        <LI><strong>Google LLC (Google Analytics 4)</strong> — látogatottsági statisztikák (EU–US Data Privacy Framework)</LI>
        <LI><strong>E-mail szolgáltató</strong> — kapcsolati e-mailek küldése</LI>
      </UL>
      <P>Adatokat harmadik félnek marketing célból nem adunk át.</P>

      <H2>6. Adatok megőrzési ideje</H2>
      <UL>
        <LI>Fiókadatok: a fiók törléséig</LI>
        <LI>Vásárlási adatok: 8 év (számviteli kötelezettség)</LI>
        <LI>Marketing hozzájárulás visszavonásáig: azonnal törlés</LI>
      </UL>

      <H2>7. Az érintett jogai (GDPR)</H2>
      <UL>
        <LI><strong>Hozzáférés joga</strong> — kérheted a rólad tárolt adatokat</LI>
        <LI><strong>Helyesbítés joga</strong> — kérheted a helytelen adatok javítását</LI>
        <LI><strong>Törlés joga</strong> — kérheted adataid törlését (bizonyos esetekben)</LI>
        <LI><strong>Adathordozhatóság joga</strong> — adataidat géppel olvasható formátumban kérheted</LI>
        <LI><strong>Tiltakozás joga</strong> — tiltakozhatsz az adatkezelés ellen</LI>
      </UL>
      <P>Kérelmedet az kftfehervari@gmail.com e-mail-címre küldheted. 30 napon belül válaszolunk.</P>

      <H2>8. Panasz</H2>
      <P>Ha úgy véled, hogy adatkezelésünk megsérti jogaidat, panaszt tehetsz a Nemzeti Adatvédelmi és Információszabadság Hatóságnál (NAIH): <a href="https://naih.hu" target="_blank" rel="noreferrer" style={{ color: 'var(--coral)' }}>naih.hu</a></P>
    </LegalLayout>
  );
}

/* ─── Elállási jog ──────────────────────────────────────── */
export function ElallasPage() {
  return (
    <LegalLayout title="Elállási jog és visszaküldési szabályzat">
      <P style={{ color: 'var(--text-muted)', fontSize: 'var(--fs-xs)' }}>A 45/2014. (II. 26.) Korm. rendelet alapján</P>

      <H2>1. Az elállási jog</H2>
      <P>Ön a termék kézhezvételétől számított <strong>14 napon belül</strong> indoklás nélkül elállhat a vásárlástól. Az elállási határidő a termék kézhezvételétől számít.</P>
      <P>Az elállási jog nem illeti meg Önt, ha a termék egyértelműen személyre szabott, vagy ha a csomagolást felbontotta és a termék egészségvédelmi vagy higiéniai okokból nem visszaküldhető.</P>

      <H2>2. Az elállás bejelentése</H2>
      <P>Elállási szándékát köteles írásban jelezni, az alábbi módok egyikén:</P>
      <UL>
        <LI>E-mailben: <a href="mailto:kftfehervari@gmail.com" style={{ color: 'var(--coral)' }}>kftfehervari@gmail.com</a></LI>
        <LI>Az alábbi elállási nyilatkozat mintával</LI>
      </UL>

      <H2>3. Elállási nyilatkozat minta</H2>
      <div style={{ background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 'var(--r-md)', padding: 'var(--sp-5)', fontSize: 'var(--fs-sm)', color: 'var(--text-2)', lineHeight: 2 }}>
        <strong>Elállási nyilatkozat</strong><br /><br />
        Alulírott kijelentem, hogy gyakorlom elállási jogomat az alábbi termék adásvételétől:<br /><br />
        Termék megnevezése: ___________________________<br />
        Rendelés száma: ___________________________<br />
        Kézhezvétel dátuma: ___________________________<br />
        Vásárló neve: ___________________________<br />
        Vásárló címe: ___________________________<br />
        Bankszámlaszám (visszautaláshoz): ___________________________<br /><br />
        Dátum: ___________________________<br />
        Aláírás (ha papíron küldik): ___________________________
      </div>

      <H2>4. A visszaküldés folyamata</H2>
      <UL>
        <LI>Az elállás bejelentése után <strong>14 napon belül</strong> köteles a terméket visszaküldeni.</LI>
        <LI>A visszaküldés <strong>költsége a vásárlót terheli</strong>.</LI>
        <LI>A terméket eredeti állapotban, sértetlenül, lehetőleg eredeti csomagolásban kell visszaküldeni.</LI>
        <LI>Visszaküldési cím: <strong>6500 Baja, Czirfusz Ferenc u. 41.</strong></LI>
      </UL>

      <H2>5. A visszatérítés</H2>
      <P>A bejelentett elállást követően, a termék visszaérkezésétől számított <strong>14 napon belül</strong> visszatérítjük a vételárat, a szállítási díj kivételével (amennyiben az eredeti szállítást mi álltuk). A visszatérítés a vásárlással megegyező fizetési módon történik, kivéve, ha kifejezetten más módban állapodunk meg.</P>

      <H2>6. Kapcsolat</H2>
      <P>Kérdés esetén keresse ügyfélszolgálatunkat:<br />
      E-mail: <a href="mailto:kftfehervari@gmail.com" style={{ color: 'var(--coral)' }}>kftfehervari@gmail.com</a><br />
      Telefon: <a href="tel:+36702107706" style={{ color: 'var(--coral)' }}>+36 70 210 7706</a></P>
    </LegalLayout>
  );
}
